import { useAuth } from '@cibo/profile'
import { Navigate } from 'react-router-dom'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { ADMIN_ROUTES } from 'navigation/types'

export const Home = () => {
  const { persona } = useAuth()

  return persona === 'grower' ? (
    <Navigate to={LAND_MANAGER_ROUTES.ROOT} replace />
  ) : (
    <Navigate to={ADMIN_ROUTES.ROOT} replace />
  )
}
